module.exports = __webpack_public_path__ + "static/media/4.9a711a09.png";